import React from 'react'

import DidYouMeanBy from './didYouMeanBy'
import AuthorSuggestions from './authorSuggestions'

const Suggestions = props => {
  const { didYouMeanByTerms, authorSuggestion, styles } = props

  return (
    <div className={styles.suggestionsContainer}>
      {authorSuggestion ? <AuthorSuggestions {...props} /> : null}
      {didYouMeanByTerms.length ? <DidYouMeanBy {...props} /> : null}
    </div>
  )
}

export default Suggestions
